// src/components/Gym/MetricCard.js

import React from 'react';

const MetricCard = ({ 
  iconClass, 
  iconBg = 'bg-focus', 
  title, 
  value, 
  trendDirection = 'up', 
  trendPercentage, 
  trendText 
}) => {
  return (

    <div className="card mb-2 widget-chart text-left">
      <div className="icon-wrapper rounded-circle">
        <div className={`icon-wrapper-bg opacity-9 ${iconBg}`}></div>
        <i className={`${iconClass} text-white`}></i>
      </div>
      <div className="widget-chart-content">
        <div className="widget-subheading">{title}</div>
        <div className="widget-numbers"><span>{value}</span></div>
        <div className="widget-description opacity-8 text-focus">
          {trendText}
          {trendPercentage && <span className={`pl-1 pr-1 text-${trendDirection === 'up' ? 'success' : 'danger'}`}>
            <i className={`fa fa-angle-${trendDirection}`}></i>
            <span className="pl-1">{trendPercentage}</span>
          </span>}
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
